import { BaseApi } from '@/modules/core/base.api';
import { PaginationResult } from '@shared/common/types';
import { PvLog } from './pv-log';

class PvLogApi extends BaseApi {
    public apiPath = 'pv-log';

    public async findAll(options: object & { page: number }): Promise<PaginationResult<PvLog>>;
    public async findAll(options?: object): Promise<PvLog[]>;
    public async findAll(options: any = {}): Promise<PvLog[] | PaginationResult<PvLog>> {
        const response = await this.api.get(this.baseUrlFor(), {
            params: {
                ...options,
            },
        });

        if (response.data.items) {
            response.data.items = response.data.items.map((pvLog: any) => new PvLog(pvLog));
        } else {
            response.data = response.data.map((pvLog: any) => new PvLog(pvLog));
        }


        return response.data;
    }

    public getExportUrl(options: any): string {
        return this.api.getUri({ url: this.baseUrlFor('export'), params: { sort: options.sort, ...options.filters } });
    }
}

export const pvLogApi = new PvLogApi();
